function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo, useState } from 'react';
import { Button, Card, Typography } from 'seagull';
import ChangesApprovalInfoBox from "../../../ChangesApprovalInfoBox/ChangesApprovalInfoBox";
import { relationshipModel, timeModel } from "../../../../models";
import styles from "./ChangesSummary.module.scss";
import { getChangesSummary } from "./ChangesSummary.utils";
import { Intent } from "../../../../infra/access-control";
import { useGlobalContext, useStoreActions } from "../../../../contexts";
import { handleRequest } from "../../../../infra/utils";
import { useApproveAmendments } from "../../../../hooks/useApproveAmendments";
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
export default function ChangesSummary(props) {
  const {
    relationship,
    testid,
    isVendor,
    refresh
  } = props;
  const {
    api,
    logBI
  } = useStoreActions();
  const globalContext = useGlobalContext();
  const approveAmendmentsRequest = useApproveAmendments();
  const [isApproving, setIsApproving] = useState(false);
  const [isDisabling, setIsDisabling] = useState(false);
  const {
    AUTO_APPROVE_INVOICE
  } = useFeatureFlags();
  const changesSummary = useMemo(() => {
    return getChangesSummary(relationship);
  }, [relationship]);
  async function approveAmendments() {
    logBI(10150);
    setIsApproving(true);
    await approveAmendmentsRequest(_objectSpread(_objectSpread({}, relationship), {}, {
      onSuccess: () => refresh({
        silent: true
      })
    }));
    setIsApproving(false);
  }
  async function disableAutoApproval() {
    logBI(10151);
    setIsDisabling(true);
    const {
      success
    } = await handleRequest(api.relationship.stopAutoApproveAmendments(relationship.id));
    if (!success) {
      globalContext.showErrorToast("Failed to ".concat(AUTO_APPROVE_INVOICE ? 'disable' : 'decline', "  auto-approval, please try again"), "".concat(AUTO_APPROVE_INVOICE ? 'disable' : 'decline', "-auto-approval-error"));
    } else {
      await refresh({
        silent: true
      });
      globalContext.showSuccessToast("".concat(AUTO_APPROVE_INVOICE ? 'Disabled' : 'Declined', " auto-approval"), "".concat(AUTO_APPROVE_INVOICE ? 'disable' : 'decline', "-auto-approval-success"));
    }
    setIsDisabling(false);
  }
  return changesSummary.length > 0 ? /*#__PURE__*/React.createElement(Card, {
    disableSeparator: true,
    skin: "info",
    title: /*#__PURE__*/React.createElement(Typography, {
      variant: "h6",
      weight: "normal"
    }, "Changes awaiting approval"),
    padding: "m",
    "data-testid": testid,
    actions: !isVendor && /*#__PURE__*/React.createElement(React.Fragment, null, relationshipModel.hasAutoAmendments(relationship) && !AUTO_APPROVE_INVOICE && /*#__PURE__*/React.createElement(Button, {
      skin: "primaryOutline",
      size: "small",
      intent: Intent.DeclineAutoApproval,
      loading: isDisabling,
      "data-testid": "".concat(testid, "-decline"),
      tooltip: {
        placement: 'top',
        title: 'Disables the auto-approval of all agreement amendments'
      },
      onClick: disableAutoApproval
    }, "Decline"), /*#__PURE__*/React.createElement(Button, {
      intent: Intent.ApproveAllAmendments,
      size: "small",
      "data-testid": "".concat(testid, "-approve"),
      loading: isApproving,
      tooltip: {
        placement: 'top',
        title: 'Approves all agreement amendments'
      },
      onClick: approveAmendments
    }, "Approve"))
  }, changesSummary.map((_ref, i) => {
    let {
      autoApprovalDate,
      changes,
      amendmentDate
    } = _ref;
    return /*#__PURE__*/React.createElement("div", {
      key: i
    }, amendmentDate && /*#__PURE__*/React.createElement(Typography, {
      className: styles.amendmentDate,
      "data-testid": "".concat(testid, "-").concat(i, "-made-on")
    }, "Made on ", timeModel.formatDate(amendmentDate)), /*#__PURE__*/React.createElement("ul", {
      className: styles.changes
    }, changes.map((text, idx) => /*#__PURE__*/React.createElement(Typography, {
      as: "li",
      variant: "paragraph2",
      key: text,
      className: styles.changeItem,
      "data-testid": "".concat(testid, "-").concat(i, "-").concat(idx)
    }, text))), autoApprovalDate && /*#__PURE__*/React.createElement(ChangesApprovalInfoBox, {
      testid: "".concat(testid, "-").concat(i, "-approval-info"),
      className: styles.approvalInfo,
      onDisable: disableAutoApproval,
      disabling: isDisabling,
      autoApprovalDate: autoApprovalDate,
      showDisableButton: !isVendor
    }));
  })) : null;
}